module.exports = __webpack_public_path__ + "static/media/modelo-b.03ffb5b9.png";